'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroRipple = require('./NitroRipple');

var _NitroRipple2 = _interopRequireDefault(_NitroRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroRipple2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-ripple/index.js
// module id = 508
// module chunks = 4